module.exports = __webpack_public_path__ + "img/Carte-JJ.c872928d.png";